import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-inlineErrorMessage",
  templateUrl: "./inlineErrorMessage.component.html",
  styleUrls: ["./inlineErrorMessage.component.css"]
})
export class InlineErrorMessageComponent implements OnInit {
  @Input() showError: boolean;
  @Input() message: any;
  @Input()
  set errorType(val: any) {
    this.createErrorMessage(val);
  }

ngOnChanges(changes: SimpleChanges) {
      for (let propName in changes) {  
    let change = changes[propName];
    let curVal  = JSON.stringify(change.currentValue);
    let prevVal = JSON.stringify(change.previousValue);
      if(curVal=='true'){
       this.createErrorMessage(curVal)
       this.showError=true;
      }
}
}
createErrorMessage(val:any){
    if(val && this.showError){
      var errorMesage = [
        { type: "maxlength", text: "You have exceeded the maxlength" },
        { type: "required", text: "This field is required" },
        { type: "pattern", text: "This field requires only valid value" }
      ];
        var filteredErrorObj = errorMesage.filter(function(item) {
          return Object.getOwnPropertyNames(val)[0] == item.type;
        });
        this.message = filteredErrorObj.length>0 ? filteredErrorObj[0].text :'This field requires a valid entry.';
  }
}
  constructor() {}
  ngOnInit() {}

}